import { render, staticRenderFns } from "./CommentUserFactorChoice.vue?vue&type=template&id=619e0af4&"
import script from "./CommentUserFactorChoice.vue?vue&type=script&lang=ts&"
export * from "./CommentUserFactorChoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports